
import { LoaderIcon } from 'vue-feather-icons'
export default {
    name: "FileListItemLoader",
    components: {
        LoaderIcon,
    },
}
